import React, { useEffect, useState } from 'react';
import AvatarContainer from '../../Avatars/AvatarContainer';
import { ListItemContainer } from '../../Containers/Containers';
import './Listitem.css';
import { Heart, HeartOutline } from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import * as localForage from 'localforage';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
  removeFromFavorites,
  addToFavourites,
  compareAndUpdateFavorites,
} from '../../../store/features/stationSlice';
import {
  updateFavouriteIfToFalse,
  updateFavouriteIfToTrue,
} from '../../../store/features/playerSlice';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmModal from '../../Modal/Modal';
import { useLocation } from 'react-router-dom';

const ListItem = ({ station, width }) => {
  const [favourite, setfavourite] = useState(station.Favorite);
  const dispatch = useDispatch();
  const location = useLocation();
  const currentStation = useSelector((state) => state.player.currentStation);
  const { provinceIdMap } = useSelector((state) => state.stations);

  const favouriteStorage = localForage.createInstance({
    name: 'favorites',
  });

  useEffect(() => {
    if (station.Id === currentStation.Id) {
      setfavourite(currentStation.favorite);
    }
  }, [currentStation, station.Id]);

  useEffect(() => {
    setfavourite(station.Favorite);
  }, [station, location]);

  const showEmptyHeart = () => (
    <div style={{ paddingRight: '30px' }}>
      <HeartOutline color={'#ee2a24'} height="25px" width="25px" />
    </div>
  );

  const showFavouriteHeart = () => (
    <div style={{ paddingRight: '30px' }}>
      <Heart color={'#ee2a24'} height="25px" width="25px" />
    </div>
  );

  const addToStorageFavorites = async (stationToSave) => {
    let data = (await favouriteStorage.getItem('favs')) ?? [];
    let breakFunction = false;
    if (data.length) {
      data.forEach((station) => {
        if (station.Id === stationToSave.Id) {
          breakFunction = true;
          return;
        }
      });
      if (breakFunction) {
        return;
      }
    }
    await favouriteStorage.setItem('favs', [...data, stationToSave]);
  };

  const removeFromStorageFavorites = async (stationToRemove) => {
    let data = (await favouriteStorage.getItem('favs')) ?? [];
    let stationIndex;
    if (data.length) {
      data.forEach((station, index) => {
        if (station.Id === stationToRemove.Id) {
          stationIndex = index;
        }
      });
      data.splice(stationIndex, 1);
    }
    await favouriteStorage.setItem('favs', data);
    data = await favouriteStorage.getItem('favs');
  };

  const toggleFavourites = async (e) => {
    e.stopPropagation();
    if (favourite) {
      await confirmAlert({
        customUI: ({ onClose }) => {
          const clickYes = async () => {
            setfavourite(false);
            await dispatch(removeFromFavorites(station));
            await removeFromStorageFavorites(station);
            dispatch(updateFavouriteIfToFalse(station));
            await onClose();
          };

          return (
            <ConfirmModal
              title={'Eliminar de favoritos'}
              accept={false}
              text={'¿Seguro que quieres eliminar esta emisora de favoritos?'}
              onClose={onClose}
              onClick={clickYes}
            />
          );
        },
      });
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          const clickYes = async () => {
            setfavourite(true);
            await dispatch(addToFavourites(station));
            await addToStorageFavorites({ favorite: favourite, ...station });
            dispatch(updateFavouriteIfToTrue(station));
            await onClose();
          };
          return (
            <ConfirmModal
              title={'Agregar a favoritos'}
              text={'¿Seguro que quieres agregar esta emisora a favoritos?'}
              onClose={onClose}
              onClick={clickYes}
            />
          );
        },
      });
      dispatch(compareAndUpdateFavorites());
    }
  };

  return (
    <ListItemContainer
      style={{
        height: width ? '75px' : '65px',
        maxWidth: width ? '460px' : '',
        padding: '10px',
      }}>
      <AvatarContainer width={width} station={station} />
      <div className="box-item" style={{ marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>{station.Name}</h3>
        <h6 style={{ margin: 0, paddingLeft: '2px', fontWeight: '500' }}>
          {provinceIdMap[station.PlaceId]?.Name || 'N/A'}
        </h6>
      </div>
      <div className="heart-container" onClick={(e) => toggleFavourites(e)}>
        {favourite || station.Favorite
          ? showFavouriteHeart()
          : showEmptyHeart()}
      </div>
    </ListItemContainer>
  );
};

export default ListItem;
